import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation as useTranslationContext } from '../contexts/TranslationContext';

export interface UseTranslationOptions {
    /** Установить язык из GET-параметра ?lang= при монтировании (например, на страницах логина/регистрации) */
    setLangFromURL?: boolean;
}

export const useTranslation = (options: UseTranslationOptions = {}) => {
    const { setLangFromURL = false } = options;
    const context = useTranslationContext();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (!setLangFromURL) return;
        const langParam = searchParams.get('lang') || '';
        if (langParam !== '') {
            context.changeLanguage(langParam, true);
        }
    }, [setLangFromURL, searchParams]);

    return context;
};
